import Item from "./Item";
import PropTypes from "prop-types";
import React from "react";
import { recordIdType } from "data/util/typedefs";
import formatId from "lib/formatId";

export default class Row extends React.Component {

    render() {
        const { columns, isActive, record, onDownloadClick, ITid } = this.props;

        const items = columns.map((column, idx) => (
                <Item
                    key={column.key}
                    ITid={formatId(ITid + "." + idx, "table-item")}
                    onDownloadClick={onDownloadClick}
                    optionsKey={column.key}
                    type={column.type}
                    ItemTemplate={column.itemTemplate}
                    renderUnsafe={record.renderUnsafe}
                    data={record.data}
                    isActive={isActive}
                    valueMap={column.expectedValueLookup}
                />
            ));

        let classes = "selection-table-row";
        if (isActive) {
            classes += " active";
        }

        return (
            <tr
                className={classes}
                onDoubleClick={this.onDoubleClick.bind(this)}
                id={formatId(ITid, "selection-table-row")}
            >
                {items}
            </tr>
        );
    }

    onDoubleClick(event) {
        event.preventDefault();
        const {
            record,
            onRecordSelection,
        } = this.props;
        onRecordSelection(record);
    }
}

Row.propTypes = {
    columns: PropTypes.array.isRequired,
    record: PropTypes.object.isRequired,
    onRecordSelection: PropTypes.func.isRequired,
    onDownloadClick: PropTypes.func,
    isActive: PropTypes.bool,
    ITid: recordIdType
};



// WEBPACK FOOTER //
// ./app/lib/common/selectiontable/lib/body/Row.js